import { render, staticRenderFns } from "./BookingTypeDialog.vue?vue&type=template&id=cffcfd8e&scoped=true"
import script from "./BookingTypeDialog.vue?vue&type=script&lang=js"
export * from "./BookingTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./BookingTypeDialog.vue?vue&type=style&index=0&id=cffcfd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffcfd8e",
  null
  
)

export default component.exports